export enum ConsentEventType {
  LANGUAGE_SWITCHED,

  REQUEST_CLOSE_CONSENT_UI,
  REQUEST_SHOW_PREFERENCES_LAYER,
  REQUEST_SHOW_EXPLICIT_LAYER,
  REQUEST_SHOW_VENDORS_LAYER
}